import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/esnext.json.parse.js";
import { transformExtent, fromLonLat, transform, toLonLat } from 'ol/proj';
import { toLine, getImg, formatRGBA, getformatstruct, getformitemsdata, getformListItemsdatas, bd_decrypt } from '@/utils/utils';
import { mapState, mapGetters, mapMutations } from 'vuex';
import mapv2assembly from '@/view/map/hdmconfigv2/map';
import mappopupv2 from '@/components/mapv2/popupv2/index';
import typev2 from '@/components/mapv2/typev2/index';
import pointlistv2 from '@/view/map/hdmconfigv2/pointlist';
import axios from 'axios';
import { BMapLoader } from '@/utils/bdMap.js';
export default {
  name: 'binzhou',
  components: {
    mapv2assembly,
    mappopupv2,
    typev2,
    pointlistv2
  },
  props: {
    // 0配置页 1展示页
    id: {
      type: Number,
      default: 1
    },
    mapform: {
      type: Object,
      default: {}
    },
    style: {
      type: Object,
      default: {}
    },
    typelist: {
      type: Array,
      default: []
    },
    isloadingmap: {
      type: Boolean,
      default: false
    },
    maplayer: {
      type: Object,
      default: {}
    },
    viewInfo: {
      type: Object,
      default: {}
    },
    streetcode: {
      type: String,
      default: ''
    },
    mappointList: {
      type: Array,
      default: []
    },
    culturalList: {
      type: Array,
      default: []
    },
    maptemplate: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      isMobile: false,
      // 移动端判断
      query: '',
      formUserId: '',
      // 最外层样式
      mainStyle: {
        width: '',
        height: '',
        transform: 'scale(1)',
        transformOrigin: '0 0',
        position: 'relative'
      },
      // 除地图以外的数据集合
      mapelem: {
        bg: '',
        logo: '',
        pickey: '',
        golist: 'https://p.ananas.chaoxing.com/star3/origin/9e8f28b6ba59d0b1acd4393f6b133747.png'
      },
      // 除地图以外的样式集合
      modulestyle: {
        logo: '',
        pickey: '',
        type: '',
        list: {}
      },
      cTemplateScore: 0,
      popmodeltype: 0,
      // 弹窗默认模板样式
      pointdetail: {},
      popshowflag: false,
      showtype: 1,
      modeltype: 0,
      showlist: 1,
      typebtn: [],
      showgolist: false,
      showgolistId: 0,
      cform: {},
      // 非遗项目表单数据
      cformlabel: {},
      // 非遗项目表单结构标题集合
      cformoption: {},
      // 非遗项目表单结构默认选择项值集合
      cformfield: {},
      // 非遗项目表单校验集合
      cstructList: [],
      // 非遗项目表单结构数据
      cpList: [],
      // 添加或编辑非遗项目表单数据时列表
      defaultcform: {},
      // 非遗项目默认form数据
      cformUser: {},
      // 地图配置当前行ID数据
      formatData: {},
      // 地图配置当前行ID 格式化数据
      sList: [],
      // 添加或编辑地图表单数据时列表
      form: {},
      // 地图表单数据
      formlabel: {},
      // 地图表单结构标题集合
      formoption: {},
      // 地图表单结构默认选择项值集合
      formfield: {},
      // 地图表单校验集合
      mapview: {},
      loadingmap: false,
      mapLayers: {},
      mapstyle: {},
      typeList: [],
      // 分类列表数据
      mapstreetcode: '',
      typeform: {
        formId: '260297',
        page: 1,
        limit: 100,
        searchStr: ''
      },
      // 分类列表查询字段
      pointform: {
        formId: '165054',
        page: 1,
        limit: 100,
        searchStr: ''
      },
      // 点位查询字段集合
      // 搜索定位点字段
      searchStr: {
        model: 0,
        filters: [{
          "model": 0,
          "filters": [{
            'alias': '40',
            'compt': 'editinput',
            'express': '===',
            'val': ''
          }]
        }, {
          "model": 1,
          "filters": []
        }]
      },
      seachType: [],
      coordinate: '',
      // 当前点击经纬度
      pointList: [],
      // 点位列表数据
      mapculturalList: [],
      // 非遗项目列表数据
      culturalform: {
        formId: 'cultural_heritage_project',
        page: 1,
        limit: 100,
        searchStr: '',
        t: '57ed207dcf924429c45100c202c62142651c83312c7ae7d68a7aa7777892039a5066948fb3dc970fc240392e22722d5c'
      },
      // 非遗项目表单字段
      mapculturalpersonList: [],
      // 非遗人列表数据 culturalHeritageInheritor202405192327
      culturalpersonform: {
        formId: 'cultural_heritage_inheritor',
        page: 1,
        limit: 100,
        searchStr: '',
        t: '57ed207dcf924429c45100c202c62142273459422eab738a2ef4681ff0d1e276d794a6b905f0918f3df30b1ce38395ba'
      },
      // 非遗人表单字段
      mapculturalpicList: [],
      // 项目图片列表数据 culturalpic2024052571429
      culturalpicform: {
        formId: '21416',
        page: 1,
        limit: 100,
        searchStr: '',
        t: '0bef8d07ada7bc791d6ebf0bcc4c8a8a'
      },
      // 项目图片表单字段
      mapculturalvideoList: [],
      // 项目视频列表数据 culturalvideo202405281701
      culturalvideoform: {
        formId: '12479',
        page: 1,
        limit: 100,
        searchStr: '',
        t: 'ebc411877446a47bd84c8cb30c90410b'
      },
      // 项目视频表单字段
      ydtypelistflag: false
    };
  },
  computed: {
    ...mapGetters(['mapv2info'])
  },
  watch: {
    mapform: {
      handler(val) {
        if (val) {
          this.form = val;
          this.mapformHandle(val);
        }
      },
      deep: true
    },
    style: {
      handler(val) {
        this.mapstyle = val;
        this.styleHandle(val);
      },
      deep: true
    },
    'style.typebtn': {
      handler(val) {
        if (val) this.typebtnFormat(val);
      },
      deep: true
    },
    'style.popcolor'(val) {
      if (val) this.popcolorFormat(val);
    },
    viewInfo: {
      handler(val) {
        this.mapview = val;
      },
      deep: true
    },
    isloadingmap(val) {
      this.loadingmap = val;
    },
    maplayer: {
      handler(val) {
        this.mapLayers = val;
      },
      deep: true
    },
    typelist: {
      handler(val) {
        this.typeList = val;
      },
      deep: true
    },
    mappointList: {
      handler(val) {
        this.pointList = val;
      },
      deep: true
    },
    culturalList: {
      handler(val) {
        this.mapculturalList = val;
      },
      deep: true
    },
    maptemplate(val) {
      this.cTemplateScore = val;
    },
    streetcode(val) {
      this.mapstreetcode = val;
    },
    'mapv2info.style.typebtn': {
      handler(val) {
        if (val) this.typebtnFormat(val);
      },
      deep: true
    },
    'mapv2info.style': {
      handler(val) {
        if (val) {
          this.styleHandle(val);
        }
      },
      deep: true
    },
    'mapv2info.style.popcolor'(val) {
      if (val) this.popcolorFormat(val);
    }
  },
  created() {
    this.mapconStyle();
  },
  mounted() {
    this.query = this.$route.query;
    this.formUserId = this.query.formUserId;
    console.log(`this.id`, this.id);
    // 展示页请求相关接口数据
    if (this.id === 1) {
      this.setComonStyle();
      this.getMapData();
    }
    this.$nextTick(() => {
      this.loadBmap();
    });
  },
  methods: {
    ...mapMutations(['SET_MAPSENIOR', 'SET_MAPVIEW', 'SET_MAPFORM', 'SET_MAPFORMITEM', 'SET_MAPSTYLEITEM', 'SET_MAPDRAWLAYER', 'SET_COORDINATE']),
    loadBmap() {
      BMapLoader().then(BMap => {
        let BDMap = new BMap.Map('bdmap');
        let geolocation = new BMap.Geolocation();
        let bdmap = {};
        geolocation.getCurrentPosition(a => {
          console.log(a);
          bdmap.address = a.address;
          bdmap.lng = a.point.lng;
          bdmap.lat = a.point.lat;
          localStorage.setItem('bdlocation', JSON.stringify(bdmap));
        });
      });
    },
    mapconStyle() {
      this.mainStyle.width = `${window.innerWidth}px`;
      this.mainStyle.height = `${window.innerHeight}px`;
      if (window.innerWidth < 1081) this.isMobile = true;
    },
    percentageChange(scale) {
      this.mainStyle.transform = `scale(${scale})`;
    },
    /**
    * 定位点格式化
    */
    posFormat(val) {
      delete val.ptype;
      delete val.pIndex;
      return val;
    },
    popcolorFormat(val) {
      let obj = formatRGBA(val);
      let theme1 = `rgba(${obj.r},${obj.g},${obj.b},1)`;
      let theme2 = `rgba(${obj.r},${obj.g},${obj.b},0.7)`;
      document.documentElement.style.setProperty('--hand-drawn-pop-colortheme1', theme1);
      document.documentElement.style.setProperty('--hand-drawn-pop-colortheme07', theme2);
    },
    styleHandle(val) {
      this.popmodeltype = val.popStyleIndex === undefined ? this.form.cTemplateScore === 1 ? 1 : 0 : val.popStyleIndex;
      this.modeltype = val.typeStyleIndex === undefined ? 0 : val.typeStyleIndex;
      Object.keys(this.modulestyle).forEach(key => {
        this.modulestyle[key] = this.posFormat(Object.keys(val).length > 0 ? {
          ...val[`${key}pos`]
        } : {
          ...this.mapv2info.style[`${key}pos`]
        });
      });
    },
    mapformHandle(val) {
      if (!this.isMobile) {
        this.mapelem.bg = val.background_img && val.background_img.length > 0 ? getImg(val.background_img[0]) : '';
      }
      if (this.isMobile) {
        this.mapelem.bg = val.app_bg_img && val.app_bg_img.length > 0 ? getImg(val.app_bg_img[0]) : '';
      }
      this.mapelem.logo = val.logo && val.logo.length > 0 ? getImg(val.logo[0]) : '';
      this.mapelem.pickey = val.pickey && val.pickey.length > 0 ? getImg(val.pickey[0]) : '';
      this.showtype = val.showtype;
      this.showlist = val.showlist;
      this.isHasallarea(val);
      if (val.cTemplateScore === 1) this.getCulturalFormStruct();
    },
    markermoveend(val) {
      console.log(`markermoveend`);
      // 非遗模版 地点数据 无层级字段 禁止缩放获取层级数据
      if (this.form.cTemplateScore === 1) return;
      if (this.id === 1) {
        this.popshowflag = false;
        this.removeAlliconsource();
        let zoom = val;
        let minZoom = this.viewInfo.minZoom;
        let orData = [];
        for (let i = minZoom; i <= zoom; i++) {
          orData.push({
            'alias': 'map_level',
            'compt': 'editinput',
            'express': '===',
            'val': i
          });
        }
        this.searchStr.filters.forEach(item => {
          if (item.model === 1) item.filters = orData;
        });
        this.pointform.searchStr = encodeURI(JSON.stringify(this.searchStr));
        this.pointform.page = 1;
        this.pointList = [];
        this.getpointData();
      } else {
        this.$emit('markermoveend', val);
      }
    },
    singleclick(val) {
      this.SET_COORDINATE(val);
    },
    /**
    * 定位点击操作
    * @param {Object} feature 选中数据
    */
    markerclick(feature) {
      console.log(feature);
      this.pointdetail = {};
      this.popshowflag = false;
      if (feature === undefined) return;
      // 判断feature类型
      let gtype = feature.getGeometry().getType();
      if (gtype === 'Point') {
        let id = feature.get('id');
        let score = feature.get('score');
        let currentInfo = '';
        if (this.pointList.length > 0) currentInfo = this.pointList.find(item => {
          return item.id === id;
        });
        if (this.mapculturalList.length > 0) currentInfo = this.mapculturalList.find(item => {
          return item.id === id;
        });
        if (currentInfo === undefined) return;
        // 标准模版获取弹窗
        if (score === 0) this.standardDetail(currentInfo);
        // 非遗模版获取弹窗
        if (score === 1) this.culturalDetail(currentInfo, feature);
      }
      if (gtype === 'Polygon' && this.form.ishaschild === '是' && this.id === 1) {
        let code = feature.get('code');
        console.log(code);
        let that = this;
        let mapform = {
          deptId: this.query.fid,
          formId: '177623',
          page: 1,
          limit: 100,
          searchStr: {
            model: 0,
            filters: [{
              "model": 0,
              "filters": [{
                'alias': '50',
                'compt': 'editinput',
                'express': 'like',
                'val': code
              }]
            }]
          }
        };
        mapform.searchStr = encodeURI(JSON.stringify(mapform.searchStr));
        this.$api.singleadvanceSearch(mapform).then(res => {
          if (res.totalRow > 0) {
            let cquery = location.hash.split('?')[1];
            let cparams = cquery.split('&');
            cparams = cparams.map(item => {
              let itemarr = item.split('=');
              if (itemarr[0] === 'formUserId') {
                itemarr[1] = res.dataList[0].id;
                item = itemarr.join('=');
              }
              return item;
            });
            window.location.href = location.protocol + '//' + location.host + location.pathname + '?page=superMapv2?' + cparams.join('&');
          }
        });
      }
    },
    /**
    * 标准模版获取点位详情
    * @param {Object} feature 选中数据
    */
    standardDetail(currentInfo) {
      let formatinfo = {};
      Object.keys(currentInfo.itemformdata).forEach(key => {
        formatinfo[key] = currentInfo.itemformdata[key];
      });
      formatinfo.audio = formatinfo.audio.length > 0 ? formatinfo.audio.map(item => {
        item.title = item.name.replace(`.${item.suffix}`, '');
        this.$api.getUrlByObjectId(item.objectId).then(res => {
          item.url = res.http;
        });
        return item;
      }) : '';
      formatinfo.video = formatinfo.video.length > 0 ? formatinfo.video.map(item => {
        item.title = item.name.replace(`.${item.suffix}`, '');
        this.$api.getUrlByObjectId(item.objectId).then(res => {
          item.url = res.http;
        });
        return item;
      }) : '';
      formatinfo.audiodesc = formatinfo.audiodesc && formatinfo.audiodesc.length > 0 ? formatinfo.audiodesc.map(item => {
        item.title = item.name.replace(`.${item.suffix}`, '');
        this.$api.getUrlByObjectId(item.objectId).then(res => {
          item.url = res.http;
        });
        return item;
      }) : '';
      console.log(`formatinfo`, formatinfo);
      if (formatinfo['42'] === '弹窗') {
        this.pointdetail = formatinfo;
        this.popshowflag = true;
      }
      if (formatinfo['42'] === '链接') {
        if (formatinfo['44'] !== '') {
          if (formatinfo.linkTarget === '是') {
            window.open(formatinfo['44']);
          } else {
            location.href = formatinfo['44'];
          }
        }
      }
    },
    /**
    * 非遗模版获取点位详情
    * @param {Object} feature 选中数据
    */
    culturalDetail(currentInfo, feature) {
      let formatinfo = {};
      let coordinate = feature.xy ? feature.xy : feature.get('xy');
      Object.keys(currentInfo.itemformdata).forEach(key => {
        formatinfo[key] = currentInfo.itemformdata[key];
      });
      formatinfo.coordinate = coordinate;
      formatinfo.gateway = formatinfo.gateway = formatinfo.detailUrl !== '' ? `${formatinfo.detailUrl}&mapid=${formatinfo.number}` : '';
      this.pointdetail = formatinfo;
      this.popshowflag = true;
      this.getCulturalperson(formatinfo);
      this.getCulturalpic(formatinfo);
      this.getCulturalvideo(formatinfo);
      if (this.popmodeltype === 1 && !this.isMobile) {
        this.$nextTick(() => {
          this.$refs.mapv2assembly.addpopOverLay(coordinate);
        });
      }
    },
    /**
    * 点位获取对应非遗传承人数据
    * @param {Object} feature 选中数据
    */
    getCulturalperson(formatinfo) {
      let searchStr = {
        model: 0,
        filters: [{
          "model": 0,
          "filters": [{
            'alias': 'project_name',
            'compt': 'editinput',
            'express': '===',
            'val': formatinfo.title
          }]
        }]
      };
      this.culturalpersonform.searchStr = encodeURI(JSON.stringify(searchStr));
      this.culturalpersonform.deptId = this.query.fid;
      let that = this;
      this.$api.singleadvanceSearchv2(this.culturalpersonform).then(res => {
        // console.log(res);
        if (res.totalRow > 0) {
          if (that.culturalpersonform.page === 1) that.mapculturalpersonList = [];
          res.dataList.forEach((item, index) => {
            let itemformdata = item.formIdValueData;
            let itemformat = {};
            Object.keys(itemformdata).forEach(key => {
              itemformat[itemformdata[key].alias] = getformListItemsdatas(itemformdata[key]);
            });
            item.itemformdata = itemformat;
          });
          that.mapculturalpersonList = that.culturalpersonform.page === 1 ? res.dataList : that.mapculturalpersonList.concat(res.dataList);
          if (res.totalPage > 1) that.culturalpersonform.page++;
          // if (res.totalPage >= that.pointform.page) that.getpointData()
          that.pointdetail.person = that.mapculturalpersonList;
        }
      });
    },
    /**
    * 点位获取对应项目图片表单数据
    * @param {Object} feature 选中数据
    */
    getCulturalpic(formatinfo) {
      let searchStr = {
        model: 0,
        filters: [{
          "model": 0,
          "filters": [{
            'alias': '19',
            'compt': 'editinput',
            'express': '===',
            'val': formatinfo.number
          }]
        }]
      };
      this.culturalpicform.searchStr = encodeURI(JSON.stringify(searchStr));
      this.culturalpicform.deptId = this.query.fid;
      let that = this;
      this.$api.singleadvanceSearchv2(this.culturalpicform).then(res => {
        // console.log(res);
        if (res.totalRow > 0) {
          if (that.culturalpicform.page === 1) that.mapculturalpicList = [];
          res.dataList.forEach((item, index) => {
            let itemformdata = item.formIdValueData;
            let itemformat = {};
            Object.keys(itemformdata).forEach(key => {
              itemformat[itemformdata[key].alias] = getformListItemsdatas(itemformdata[key]);
            });
            item.itemformdata = itemformat;
          });
          that.mapculturalpicList = that.culturalpicform.page === 1 ? res.dataList : that.mapculturalpicList.concat(res.dataList);
          if (res.totalPage > 1) that.culturalpicform.page++;
          // if (res.totalPage >= that.pointform.page) that.getpointData()
          that.pointdetail.pictureList = that.mapculturalpicList;
        }
      });
    },
    /**
    * 点位获取对应项目视频表单数据
    * @param {Object} feature 选中数据
    */
    getCulturalvideo(formatinfo) {
      let searchStr = {
        model: 0,
        filters: [{
          "model": 0,
          "filters": [{
            'alias': '1',
            'compt': 'selectbox',
            'express': '===',
            'val': [formatinfo.title]
          }]
        }]
      };
      this.culturalvideoform.searchStr = encodeURI(JSON.stringify(searchStr));
      this.culturalvideoform.deptId = this.query.fid;
      let that = this;
      this.$api.singleadvanceSearchv2(this.culturalvideoform).then(res => {
        // console.log(res);
        if (res.totalRow > 0) {
          if (that.culturalvideoform.page === 1) that.mapculturalvideoList = [];
          res.dataList.forEach((item, index) => {
            let itemformdata = item.formIdValueData;
            let itemformat = {};
            Object.keys(itemformdata).forEach(key => {
              itemformat[itemformdata[key].alias] = getformListItemsdatas(itemformdata[key]);
            });
            item.itemformdata = itemformat;
          });
          that.mapculturalvideoList = that.culturalvideoform.page === 1 ? res.dataList : that.mapculturalvideoList.concat(res.dataList);
          // if (res.totalPage > 1) that.culturalvideoform.page++
          // if (res.totalPage >= that.pointform.page) that.getpointData()
          that.pointdetail.videoList = that.mapculturalvideoList;
        }
      });
    },
    /**
    * 弹窗关闭事件
    */
    closeHandle() {
      this.popshowflag = false;
      this.pointdetail = {};
    },
    /**
    * 分类选择事件
    */
    typeselect(val) {
      if (this.id === 1) {
        this.typeClick(val);
      } else {
        this.$emit('typeselect', val);
      }
    },
    /**
     * 分类数据格式化
     */
    typebtnFormat(val) {
      let typebtn = [...val];
      this.typebtn = [];
      typebtn.forEach(elem => {
        let item = {
          ...elem
        };
        if (item.imgList && item.imgList.length > 0) {
          item.backgroundImage = 'url(\'' + getImg(item.imgList[0]) + '\')';
          item.backgroundSize = '100% 100%';
          item.backgroundRepeat = 'no-repeat';
        }
        item.textAlign = 'center';
        delete item.imgList;
        let newitem = {};
        Object.keys(item).forEach(child => {
          newitem[toLine(child)] = item[child];
        });
        this.typebtn.push(newitem);
      });
    },
    removeAlliconsource() {
      this.$refs.mapv2assembly.removeAlliconsource();
    },
    saveDrawHandle() {
      this.$refs.mapv2assembly.saveDrawHandle();
    },
    // changeToolHandle (val) {
    //     this.$refs.mapv2assembly.changeToolHandle(val)
    // },
    updateMap() {
      this.$refs.mapv2assembly.updateMap();
    },
    isHasallarea(val) {
      let that = this;
      let mapform = {
        deptId: this.query.fid,
        formId: '177623',
        page: 1,
        limit: 100,
        searchStr: {
          model: 0,
          filters: [{
            "model": 0,
            "filters": [{
              'alias': 'ishaschild',
              'compt': 'radiobutton',
              'express': '===',
              'val': ['是']
            }]
          }]
        }
      };
      mapform.searchStr = encodeURI(JSON.stringify(mapform.searchStr));
      this.$api.singleadvanceSearch(mapform).then(res => {
        console.log(`isHasallarea`);
        console.log(res);
        if (res.totalRow > 0) {
          this.showgolist = val.ishaschild === '是' ? false : true;
          if (this.showgolist) this.showgolistId = res.dataList[0].id;
        }
      });
    },
    golist() {
      let cquery = location.hash.split('?')[1];
      let cparams = cquery.split('&');
      cparams = cparams.map(item => {
        let itemarr = item.split('=');
        if (itemarr[0] === 'formUserId') {
          itemarr[1] = this.showgolistId;
          item = itemarr.join('=');
        }
        return item;
      });
      window.location.href = location.protocol + '//' + location.host + location.pathname + '?page=superMapv2?' + cparams.join('&');
    },
    /**
     * 获取非遗项目表单结构数据
     */
    getCulturalFormStruct() {
      let params = {
        deptId: this.query.fid,
        formId: 'cultural_heritage_project'
      };
      this.$api.formStruct(params).then(res => {
        this.cstructList = JSON.parse(JSON.stringify(res));
        this.cpList = getformatstruct(res, this.cform, this.cformlabel, this.cformfield, this.cformoption);
        this.defaultcform = Object.assign({}, this.cform);
        console.log(`获取非遗项目表单结构数据`);
        console.log(this.cform);
        console.log(this.cformoption);
      });
    },
    setComonStyle() {
      document.querySelector('html').style.fontSize = `${window.screen.width / 10}px`;
    },
    /**
     * 获取地图设置行
     */
    getMapData() {
      let that = this;
      this.$api.singleformUserId(this.query.fid, '177623', this.query.formUserId).then(res => {
        if (res.formUserList.length > 0) {
          that.cformUser = res.formUserList[0];
          let formatData = {};
          res.formUserList[0].formData.forEach(item => {
            formatData[item.alias] = getformitemsdata(item);
          });
          that.formatData = formatData;
          document.title = formatData.toptitle;
          // 处理地图view相关字段
          that.getFormStruct();
        }
      });
    },
    /**
     * 获取地图配置表单结构
     */
    getFormStruct() {
      let params = {
        deptId: this.$route.query.fid,
        formId: 177623
      };
      this.$api.formStruct(params).then(res => {
        this.sList = getformatstruct(res, this.form, this.formlabel, this.formfield, this.formoption);
        this.mapview = this.mapv2info.view;
        this.editlogic(this.formatData);
        this.gettypeList();
      });
    },
    /**
     * 配置页编辑逻辑处理
     */
    editlogic(data) {
      this.mapLayers.json = true;
      this.mapLayers.static = true;
      Object.keys(data).forEach(item => {
        this.form[item] = data[item];
      });
      let jsonOption = {
        ...JSON.parse(this.form.jsontxt.replace(/(<\/?p.*?>)/gi, ''))
      };
      this.mapviewhandle(jsonOption.view);
      this.form.showtype = jsonOption.style.showtype;
      this.form.showlist = jsonOption.style.showlist;
      this.form.scale = jsonOption.view.scale;
      this.form.rotate = jsonOption.view.rotate;
      console.log(`this.form`);
      console.log(this.form);
      this.SET_MAPFORM(this.form);
      this.SET_MAPVIEW(jsonOption.view);
      this.SET_MAPSENIOR(jsonOption.senior);
      this.SET_MAPSTYLEITEM({
        showtype: jsonOption.style.showtype
      });
      this.SET_MAPSTYLEITEM({
        showlist: jsonOption.style.showlist
      });
      this.mapview = jsonOption.view;
      if (this.isMobile) {
        this.mapview.zoom = 9;
        this.mapview.minZoom = 9.3;
        this.mapview.maxZoom = 12;
        this.mapview.center = [117.8599974, 37.493542];
        jsonOption.style.pointpic.scale = 0.5;
      }
      this.mapstyle = jsonOption.style;
      this.senior = jsonOption.senior;
      if (this.form.static_img && this.form.static_img.length > 0) this.mapLayers.staticimage = getImg(this.form.static_img[0]);

      // 判断当前地图模版 score  0标准模版  1非遗模版
      this.formoption.mapTemplate.forEach(elem => {
        if (this.formatData.mapTemplate === elem.title) {
          this.cTemplateScore = elem.score;
          this.SET_MAPFORMITEM({
            cTemplateScore: elem.score
          });
        }
      });
      this.SET_MAPDRAWLAYER(jsonOption.drawlayer);
      this.mapLayers.drawelement = jsonOption.drawlayer;
      this.mapformHandle(this.form);
      this.$nextTick(() => {
        this.styleHandle(jsonOption.style);
        this.typebtnFormat(jsonOption.style.typebtn);
        this.popcolorFormat(jsonOption.style.popcolor);
      });
      // 是否含有乡镇街道
      console.log(jsonOption);
      if (jsonOption.geojson.adcode === undefined) this.mapstreetcode = jsonOption.geojson.code;
      console.log(this.mapstreetcode);
      let adcode = jsonOption.view.adcode;
      if (this.mapstreetcode !== '') {
        axios.get(`${process.env.NODE_ENV === 'development' ? '/fileapi' : location.origin}/frontendTest1/openlayers/data/${adcode}.json`).then(res => {
          console.log(res);
          if (res.status === 200) {
            let cjson = res.data.features.filter(item => {
              return Number(item.properties.code) === Number(this.mapstreetcode);
            });
            console.log(cjson);
            if (cjson.length > 0) {
              let datacoord = cjson[0].geometry.coordinates[0];
              console.log(datacoord);
              let changedata = [];
              datacoord.forEach(elem => {
                changedata.push(transform(elem, 'EPSG:4326', 'EPSG:3857'));
              });
              console.log(changedata);
              cjson[0].geometry.coordinates[0] = changedata;
              console.log(this.mapLayers.geojson);
              this.mapLayers.geojson = {
                type: 'FeatureCollection',
                features: cjson
              };
              this.loadingmap = true;
              console.log(`this.loadingmap`, this.loadingmap);
            }
          }
        }).catch(error => {});
        return;
      }
      this.loadingmap = true;
    },
    mapviewhandle(view) {
      let center = view.center;
      this.form.centerX = center[0];
      this.form.centerY = center[1];
      this.form.minZoom = view.minZoom;
      this.form.maxZoom = view.maxZoom;
      this.form.zoom = view.zoom;
      this.form.static_map_min_level = view.minZoom;
      this.form.static_map_max_level = view.maxZoom;
      this.form.current_level = view.zoom;
      this.form.map_center = center.join(',');
      this.form.transform_extent = view.extent.join(',');
    },
    /**
     * 获取分类列表数据
     */
    gettypeList() {
      let that = this;
      this.typeform.deptId = this.query.fid;
      this.$api.singleadvanceSearch(this.typeform).then(res => {
        // console.log(res);
        if (res.totalRow > 0) {
          that.typeList = [];
          res.dataList.forEach((item, index) => {
            let itemformdata = item.formIdValueData;
            let itemformat = {};
            Object.keys(itemformdata).forEach(key => {
              itemformat[itemformdata[key].alias] = getformListItemsdatas(itemformdata[key]);
            });
            item.itemformdata = itemformat;
          });
          this.typeList = res.dataList.sort((a, b) => Number(a.itemformdata.sortId) - Number(b.itemformdata.sortId));
        }
        this.typeList = this.typeList.map((item, index) => {
          let newItem = item;
          let children = [...JSON.parse(item.itemformdata.json.replace(/(<\/?p.*?>)/gi, ''))];
          children.forEach(child => {
            child.flag = false;
          });
          children.unshift({
            title: '全部',
            flag: true
          });
          children[0].flag = true;
          item.itemformdata.children = children;
          return newItem;
        });
        console.log(this.typeList);
        this.pointform.deptId = this.query.fid;
        this.searchStr.filters[0].filters[0].val = this.formatData.title;
        this.typeClick(this.typeList[0], 0, this.typeList[0].itemformdata.children[0]);

        // 处理地点管理表 请求参数
        // this.pointform.deptId = this.query.fid
        // this.searchStr.filters[0].filters[0].val = this.formatData.title
        // this.pointform.searchStr = encodeURI(JSON.stringify(this.searchStr))
        // this.getpointData()

        // 处理非遗项目表单数据
        if (this.cTemplateScore === 1) {
          let searchStr = {
            model: 0,
            filters: [{
              "model": 0,
              "filters": [{
                'alias': 'correlation_map',
                'compt': 'selectbox',
                'express': '===',
                'val': ['是']
              }]
            }]
          };
          this.culturalform.searchStr = encodeURI(JSON.stringify(searchStr));
          this.culturalform.deptId = this.query.fid;
          this.getIntangibleCulturalHeritageData();
        }
      });
    },
    /**
     * 获取地点管理表数据
     */
    getpointData() {
      let that = this;
      this.$api.singleadvanceSearch(this.pointform).then(res => {
        // console.log(res);
        if (res.totalRow > 0) {
          if (that.pointform.page === 1) that.pointList = [];
          that.pointdataformat(res);
          if (res.totalPage > 1) that.pointform.page++;
          // if (res.totalPage >= that.pointform.page) that.getpointData()
        }
      });
    },
    pointdataformat(res) {
      res.dataList.forEach((item, index) => {
        let itemformdata = item.formIdValueData;
        let itemformat = {};
        Object.keys(itemformdata).forEach(key => {
          itemformat[itemformdata[key].alias] = getformListItemsdatas(itemformdata[key]);
        });
        item.itemformdata = itemformat;
      });
      this.pointList = this.pointform.page === 1 ? res.dataList : this.dataList.concat(res.dataList);
    },
    /**
     * 点击类型操作
     * @param {Object} item 选中数据
     * @param {Object} index 选中索引
     * @param {Object} child 选中名称
     */
    typeClick(item, index, child) {
      console.log(item);
      console.log(index);
      console.log(child);
      this.typeList[index].itemformdata.children.forEach(elem => {
        elem.flag = elem.title === child.title ? true : false;
      });
      this.seachType[index] = child.title === '全部' ? '' : `${item.itemformdata.title}/${child.title}`;
      let searchTitle = this.seachType.filter(item => {
        return item !== '';
      }).join(',');
      console.log(this.seachType);
      console.log(this.seachType.filter(item => {
        return item !== '';
      }).join(','));
      this.popshowflag = false;
      this.removeAlliconsource();
      let typesearchflag = false;
      this.searchStr.filters.forEach(item => {
        if (item.filters.length > 0 && item.filters[0].alias === 'map_type2') {
          item.filters[0].val = searchTitle;
          typesearchflag = true;
        }
      });
      if (!typesearchflag) {
        this.searchStr.filters.push({
          "model": 0,
          "filters": [{
            'alias': 'map_type2',
            'compt': 'editinput',
            'express': 'like',
            'val': searchTitle
          }]
        });
      }
      this.pointform.searchStr = encodeURI(JSON.stringify(this.searchStr));
      this.pointform.page = 1;
      this.pointList = [];
      this.getpointData();
    },
    /**
     * 获取非遗项目表单数据
     */
    getIntangibleCulturalHeritageData() {
      let that = this;
      this.$api.singleadvanceSearchv2(this.culturalform).then(res => {
        // console.log(res);
        if (res.totalRow > 0) {
          if (that.culturalform.page === 1) that.mapculturalList = [];
          that.culturaldataformat(res);
          if (res.totalPage > 1) that.culturalform.page++;
          // if (res.totalPage >= that.pointform.page) that.getpointData()
        }
      });
    },
    culturaldataformat(res) {
      res.dataList.forEach((item, index) => {
        let itemformdata = item.formIdValueData;
        let itemformat = {};
        Object.keys(itemformdata).forEach(key => {
          itemformat[itemformdata[key].alias] = getformListItemsdatas(itemformdata[key]);
        });
        if (this.typeList.length > 0) {
          let type = this.typeList.find(elem => {
            return elem.itemformdata.title === itemformat.level;
          });
          if (type && type.itemformdata.icon.length > 0) itemformat.icon = getImg(type.itemformdata.icon[0]);
        }
        item.itemformdata = itemformat;
      });
      this.mapculturalList = this.culturalform.page === 1 ? res.dataList : this.mapculturalList.concat(res.dataList);
    },
    pointlistClick(item) {
      this.pointdetail = {};
      this.popshowflag = false;
      let citem = item.itemformdata;
      if (citem.correlation_address.length > 0) {
        let gd = bd_decrypt(Number(citem.correlation_address[0].lng), Number(citem.correlation_address[0].lat));
        let x = Number(gd.lng);
        let y = Number(gd.lat);
        this.culturalDetail(item, {
          xy: [x, y]
        });
      }
    }
  }
};